import { useState, useRef, useEffect } from 'react';

const Connect = () => {

  const scrollRef = useRef(null);
  const [fixed, setFixed] = useState(false); // default to true
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const top = scrollRef.current.getBoundingClientRect().top;
      if (top > 150) {
        setFixed(false);
      } else {
        setFixed(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (<div className={`connect-overlay`}>
    <div className={`connect`} ref={scrollRef} id="home-owner-portal">
      <div className="connect-section">
        <div className="connect-detail">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex">
              <div className="connect-header">ABM Link</div>
              <div className="vector-logo">
                <img
                  src="assets/img/vector-1.png"
                  className="vector-one"
                  alt=""
                />
                <img src="assets/img/vector.png" className="vector" alt="" />
              </div>
            </div>
            <div className="connect-logo">
              <img src="assets/img/abm.png" alt="" />
            </div>
          </div>
          <div className="connect-title">Future-Forward Innovation</div>
          <div className="connect-subtitle">
            At ABM, innovation, technology, and convenience are at the heart of
            everything we do. We're constantly exploring new ways to enhance the
            client experience. With features like ABM Link, our exclusive
            online portal offering 24/7 access to Association documents and
            account details, ABM is transforming the future of property
            management.
          </div>
          <div className="connect-btn">
            <button onClick={() => {
              window.open('https://portal.abmpropertymgmt.com/login', '_blank');
            }} className="btn btn-primary learn-more-button">
              HOMEOWNER PORTAL
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Connect;
